module.exports = __webpack_public_path__ + "static/media/sqlserver-logo.f37f6572.png";